import { createRouter, createWebHashHistory } from 'vue-router'
import HomePage from './components/HomePage.vue'
import SearchPage from './components/SearchPage.vue'
import HistoryPage from './components/HistoryPage.vue'

const routes = [
  { path: '/', redirect: '/home' },
  { path: '/home',   component: HomePage },
  { path: '/search', component: SearchPage },
  { path: '/history',component: HistoryPage },
]

export default createRouter({
  history: createWebHashHistory(),
  routes
})